<app-master-list
  [items]="results$ | async"
  [headers]="headers"
  [sortByHeader]="sortByHeader$ | async"
  [groupByFn]="groupByFn"
  [noItemsOptions]="noResultsOptions$ | async"
  [lastPageFetched]="lastPageFetched$ | async"
  [fetchingList]="fetchingList$ | async"
  [enablePagination]="true"
  [enableBulkActions]="enableBulkActions"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  class="search-list"
  (onInfinitePagination)="fetchNextPage()"
  (onToggleSorting)="sortList($event)"
>
  <ng-template
    let-entity="entity"
    let-selected="selected"
    let-position="position"
  >
    <ng-container
      *ngTemplateOutlet="
        template;
        context: { entity: entity, position: position, selected: selected }
      "
    ></ng-container>
  </ng-template>
</app-master-list>
